// Auto generated file, do not manually modify!
// com.hotpads.cometuserauthdtos.identityverification.CometUserIdentityVerificationCohort

export enum CometUserIdentityVerificationCohort {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}

export const CometUserIdentityVerificationCohort_values = [
  CometUserIdentityVerificationCohort.EXISTING,
  CometUserIdentityVerificationCohort.NEW,
] as const;
